/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useBlocker } from '../../helper/Hooks';
import ConfirmDialog from '../admin/ConfirmDialog';

export const UnsavedChangesDialog = ({ when }: { when: boolean }) => {
	const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState<false | { confirm: () => {} }>(false);
	const blockerCallback = useCallback((blocker) => {
		setShowUnsavedChangesDialog({ confirm: () => blocker.retry() });
	}, []);

	useBlocker(blockerCallback, when);

	return showUnsavedChangesDialog ? (
		<ConfirmDialog
			open={!!showUnsavedChangesDialog}
			onConfirm={() => {
				showUnsavedChangesDialog.confirm();
				setShowUnsavedChangesDialog(false);
			}}
			title={<FormattedMessage id="UnsavedChangesDialog.title" defaultMessage="Unsaved Changes" />}
			content={
				<FormattedMessage
					id="UnsavedChangesDialog.content"
					defaultMessage="You have unsaved changes. Continuing will discard your unsaved changes."
				/>
			}
			confirmMessage={
				<FormattedMessage id="UnsavedChangesDialog.confirm" defaultMessage="Discard changes and continue" />
			}
			cancelMessage={<FormattedMessage id="UnsavedChangesDialog.cancel" defaultMessage="Go back" />}
			onCancel={() => setShowUnsavedChangesDialog(false)}
		/>
	) : null;
};
